import type { ComponentProgressDetailView } from '@/types/coaching'

export type QuizPurpose =
  | 'selected'
  | 'review'
  | 'block'
  | 'checkup'
  | 'applied'
  | 'wrapup'
  | 'aiq'

const QUIZ_PURPOSES: readonly QuizPurpose[] = [
  'selected', 'review', 'block', 'checkup', 'applied', 'wrapup', 'aiq',
]

export type PurposeBadgeData =
  | { kind: 'quiz'; purpose: QuizPurpose }
  | { kind: 'toon'; toonType: 'intro' | 'outro' | 'intro_outro' }
  | null

export function derivePurposeBadge(c: ComponentProgressDetailView): PurposeBadgeData {
  if (c.type === 'quiz') {
    const raw = c.quiz?.quizLocations?.[0]
    return isQuizPurpose(raw) ? { kind: 'quiz', purpose: raw } : null
  }
  if (c.type === 'toon') {
    const tt = c.toon?.toonType
    return tt ? { kind: 'toon', toonType: tt } : null
  }
  return null
}

function isQuizPurpose(v: unknown): v is QuizPurpose {
  return typeof v === 'string' && (QUIZ_PURPOSES as readonly string[]).includes(v)
}
